import { useEffect, useState } from "react"; // React Hooks
import React from "react";
import axios from "axios"; //Axios for API calls
import TableOne from "../Table/TableOne"; // Import your table component
import Modal from "react-modal"; // Modal for adding/editing companies
import "./../style/modal.css";
import "./../style/common.css";
import "./../Table/table.css";
import "./../style/pop-up.css";
// import "font-awesome/css/font-awesome.min.css";
import { CiWarning } from "react-icons/ci";
import { ToastContainer, toast } from "react-toastify"; // Notifications
// UI Components from Material UI & Ant Design
import { TextField, MenuItem, InputAdornment } from "@mui/material";
// Icons for UI elements
import { AiOutlineProject } from "react-icons/ai";
import { MdEmail, MdBadge, MdPreview, MdDelete } from "react-icons/md";
import {
  FaBuilding,
  FaAddressCard,
  FaFileUpload,
} from "react-icons/fa";
import { TbMapPinCode } from "react-icons/tb";
import { FaMobileRetro } from "react-icons/fa6";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";


const Company = () => {
  // Store company, country, state, and city data
  const [company, setCompany] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state for API calls
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state (for adding/editing a company)
  // State for filtered companies (search functionality)
  const [filteredCompany, setFilteredCompanys] = useState([]); // For search functionality store
  const [errors, setErrors] = useState({}); //error show statendling state(Validation Errors)
  // Define state variables for deletion
  const [deleteCompanyName, setDeleteCompanyName] = useState("");
  const [deleteCompanyId, setDeleteCompanyId] = useState(null);
  const [showDeleteCompanyBox, setShowDeleteCompanyBox] = useState(false);
  
  // Define state variables for file deletion
  const [showDeleteFileBox, setShowDeleteFileBox] = useState(false);
  const [deleteFileCompanyId, setDeleteFileCompanyId] = useState(null);

  // Define state variables for logo uploading
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [addressDialogOpen, setAddressDialogOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  // Form data for creating/updating a company
  const [formData, setFormData] = useState({
    company_country: "", //FK Country Master
    company_state: "", //FK State Master
    company_city: "", //FK City Master
    company_name: "",
    company_email: "",
    company_contact: "",
    company_address: "",
    company_pincode: "",
    company_type: "",
    company_logo: "",
    company_attachfile: "",
  });
  const [editMode, setEditMode] = useState(false); // Edit mode flag




  //edit
  const handleEdit = (c) => {
    console.log("Editing Company Data:", c);
    setFormData({
      company_id: c.CompanyId,
      company_country: c.Country || "",
      company_state: c.State || "",
      company_city: c.City || "",
      company_name: c.CompanyName || "",
      company_email: c.CompanyEmail || "",
      company_contact: c.CompanyContact || "",
      company_address: c.CompanyAddress || "",
      company_pincode: c.CompanyPincode || "",
      company_type: c.CompanyType || "",
      company_logo: c.CompanyLogo || "",
      company_attachfile: c.CompanyAttach || "",
    });
    setEditMode(true);
    setIsModalOpen(true);
    // Fetch states and cities when editing
    if (c.Country) {
      fetchState(c.Country);
    }
    if (c.State) {
      fetchCity(c.State);
    }
  };


  //delete
  // Handle delete action for company, set company name and ID
  const handleDelete = async (c) => {
    const company_id = c.CompanyId;
    const company_name = c.CompanyName; // Get the company name for display
    if (!company_id) {
      toast.error("Invalid company ID. Please try again.");
      return;
    }
    // Set company name and ID to state before showing the pop-up
    setDeleteCompanyName(company_name); // Dynamically set the company name
    setDeleteCompanyId(company_id); // Dynamically set the company ID
    setShowDeleteCompanyBox(true); // Show the confirmation popup
  };


  // Confirm delete action for company
  const confirmDeleteCompany = async () => {
    if (!deleteCompanyId) return;
    try {
      const response = await axios.delete(
        `/api/company/delete/${deleteCompanyId}`
      );
      console.log("response", response);
      if (response.status === 200) {
        toast.success("Company deleted successfully!");
        console.log("success delete");
        const updatedCompanys = company.filter(
          (item) => item.CompanyId !== deleteCompanyId
        );
        setCompany(updatedCompanys); // Update the company state after deletion
        setFilteredCompanys(updatedCompanys); // Ensure filtered list is also updated
      }
      setShowDeleteCompanyBox(false); // Close the confirmation box after deletion
    } catch (error) {
      console.error("Error deleting Company:", error);
      toast.error("An error occurred while deleting the Company.");
      setShowDeleteCompanyBox(false); // Close the box on error
    }
  };


  // Cancel delete action for company
  const cancelDeleteCompany = () => {
    setShowDeleteCompanyBox(false); // Close the confirmation box without deleting
  };


  //logo confirmation
  const handleImageSelection = (CompanyId, CompanyName, img) => {
    if (!img) {
      toast.error("Please select an image.");
      return;
    }
    console.log("Image selected for upload:", img); // Debugging
    setSelectedImage(img);
    setSelectedCompanyId(CompanyId);
    setSelectedCompanyName(CompanyName);
    setIsUploadModalOpen(true); // Open confirmation modal
  };


  const confirmImageUpload = async () => {
    if (!selectedImage || !selectedCompanyId) return;
    const formData = new FormData();
    formData.append("company_logo", selectedImage);
    setIsUploadModalOpen(false);
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/companylogo/add-image/${selectedCompanyId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Image uploaded successfully!");
        fetchCompanys(); // Refresh company after upload
      } else {
        toast.error("Failed to upload image.");
        setLoading(false);
      }
    } catch (error) {
      console.error("Image upload error:", error);
      if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.company_logo) {
        toast.error(error.response.data.errors.company_logo[0]);
      } else if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error);
      } else if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to upload image. Please try again.");
      }
      setLoading(false);
    }
    setIsUploadModalOpen(false); // Close the confirmation modal
    setSelectedImage(null);
    setSelectedCompanyId(null);
    setSelectedCompanyName("");
  };
  const cancelImageUpload = () => {
    setIsUploadModalOpen(false);
    setSelectedImage(null);
    setSelectedCompanyId(null);
    setSelectedCompanyName("");
  };


  // Fetch Country data from the API
  const fetchCountry = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "/api/countries"
      );
      if (response.data && response.data.success) {
        const countryData = response.data.data.map((country) => ({
          CountryId: country.id,
          CountryName: country.name,
        }));
        setCountry(countryData);
      } else {
        console.error("Invalid country response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
    setLoading(false);
  };
  // Fetch State data based on selected Country
  const fetchState = async (countryId) => {
    if (!countryId) return;
    try {
      const response = await axios.get(
        `/api/states/${countryId}`
      );
      if (response.data && response.data.success) {
        const stateData = response.data.data.map((state) => ({
          StateId: state.id,
          StateName: state.name,
        }));
        setState(stateData);
      } else {
        console.error("Invalid state response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };
  // Fetch City data based on selected State
  const fetchCity = async (stateId) => {
    if (!stateId) return;
    try {
      const response = await axios.get(
        `/api/cities/${stateId}`
      );
      if (response.data && response.data.success) {
        const cityData = response.data.data.map((city) => ({
          CityId: city.id,
          CityName: city.name,
        }));
        setCity(cityData);
      } else {
        console.error("Invalid city response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };
  useEffect(() => {
    fetchCountry(); // Fetch countries on component mount
  }, []);
  useEffect(() => {
    if (formData.company_country) {
      fetchState(formData.company_country);
      setFormData((prev) => ({ ...prev, company_state: "", company_city: "" }));
    }
  }, [formData.company_country]);
  useEffect(() => {
    if (formData.company_state) {
      fetchCity(formData.company_state);
      setFormData((prev) => ({ ...prev, company_city: "" }));
    }
  }, [formData.company_state]);


  //featch Company data from the API
  const fetchCompanys = async () => {
    setLoading(true);
    try {
      // Fetch the company
      const response = await axios.get(
        "/api/company"
      );
      const companyData = response.data.company.map((c) => ({
        CompanyId: c.company_id,
        Country: c.country?.name || "N/A", // Fetch name directly if API provides it
        State: c.state?.name || "N/A", // Fetch name directly if API provides it
        City: c.city?.name || "N/A", // Fetch name directly if API provides it
        CompanyName: c.company_name,
        CompanyEmail: c.company_email,
        CompanyContact: c.company_contact,
        CompanyAddress: c.company_address,
        CompanyPincode: c.company_pincode,
        CompanyType: c.company_type,
        CompanyLogo: c.company_logo || "../images/imageicon.png", // Default image callback,
        CompanyAttach: c.company_attachfile,
      }));
      if (companyData.length > 0) {
      }
      console.log("Company Data main->>", companyData.state);
      // Update tasks state with the enriched data
      setCompany(companyData);
      setFilteredCompanys(companyData); //Initialize search data
    } catch (error) {
      console.error("Error Fetching CompanyData", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchCompanys(); // Fetch data only when the component first appears
    console.log("Component Mounted!");
  }, []); // Runs only once, when the component first appears


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const openModal = (companyData = null) => {
    if (companyData) {
      setFormData(companyData);
      // setEditMode(true);
    } else {
      setFormData({
        company_id: "",
        company_country: "",
        company_state: "",
        company_city: "",
        company_name: "",
        company_email: "",
        company_contact: "",
        company_address: "",
        company_pincode: "",
        company_type: "",
        company_logo: "",
        company_attachfile: "",
      });
      setEditMode(false);
    }
    setIsModalOpen(true);
    // Reset validation errors
    setErrors({});
  };


  const closeModal = () => {
    setIsModalOpen(false);
  };


  // Handle Form Submission both adding and updating a company.
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit--->");


    //Validate the form
    const validateForm = () => {
      const newErrors = {};


      if (!formData.company_name) {
        newErrors.company_name = "Company name is required.";
      } else {
        const duplicateCompany = company.find(
          (c) =>
            c.CompanyName.toLowerCase() ===
              formData.company_name.toLowerCase() &&
            c.CompanyId !== formData.company_id // Allow same company to keep its name
        );
        if (duplicateCompany) {
          newErrors.company_name = "Company name already exists!";
        }
      }
      if (!formData.company_email) {
        newErrors.company_email = "Email is required.";
      } else if (!/\S+@\S+\.\S+/.test(formData.company_email)) {
        newErrors.company_email = "Please enter a valid email address.";
      } else {
        const duplicateEmail = company.find(
          (c) =>
            c.CompanyEmail.toLowerCase() ===
              formData.company_email.toLowerCase() &&
            c.CompanyId !== formData.company_id // Allow same company to keep its email
        );
        if (duplicateEmail) {
          newErrors.company_email = "Email already exists!";
        }
      }
      if (!formData.company_contact) {
        newErrors.company_contact = "Contact number is required.";
      } else if (!/^\d{10}$/.test(formData.company_contact)) {
        newErrors.company_contact = "Contact number must be 10 digits.";
      }
      if (!/^\d{6}$/.test(formData.company_pincode)) {
        newErrors.company_pincode = "Pincode must be 6 digits.";
      }
      return newErrors;
    };


    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors); // Set errors in state for display
      return; // Stop the submission
    }
    try {
      const url = editMode
        ? `/api/company/update/${formData.company_id}`
        : "/api/company/add";


      const method = editMode ? "put" : "post";
      await axios({
        method,
        url,
        data: formData, // <--- This is the payload being sent to the API
      });
      toast.success(
        editMode
          ? "Company updated successfully!"
          : "Company added successfully!"
      );
      fetchCompanys(); // Refresh data
      closeModal();
      setErrors({}); // Clear errors after successful submission
    } catch (error) {
      console.error("Error submitting data:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };


  //for upload file attachment
  const handleFileUpload = async (CompanyId, file) => {
    console.log("file uplpoad", file);
    if (!file) {
      toast.error("Please select a file.");
      return;
    }


    const formData = new FormData();
    formData.append("company_attachfile", file);
    setLoading(true);
    try {
      const response = await axios.post(
        `/api/company/add-document/${CompanyId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("File uploaded successfully!");
        fetchCompanys(); // Refresh tasks after upload
      } else {
        toast.error("Failed to upload file.");
      }
    } catch (error) {
      console.error("File upload error:", error);
      if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.company_attachfile) {
        toast.error(error.response.data.errors.company_attachfile[0]);
      } else if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error);
      } else if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to upload file. Please try again.");
      }
    }
    setLoading(false);
  };


  const handleFileDelete = (c) => {
    const company_id = c.CompanyId;
    if (!company_id) {
      toast.error("Invalid company ID. Please try again.");
      return;
    }
    setDeleteFileCompanyId(company_id);
    setShowDeleteFileBox(true); // Show custom confirmation popup
  };

  const confirmDeleteFile = async () => {
    if (!deleteFileCompanyId) return;
    try {
      const response = await axios.delete(
        `/api/company/delete-document/${deleteFileCompanyId}`
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Deleted successfully!");
        fetchCompanys();
      }
    } catch (error) {
      console.error("Error deleting Company File:", error);
      toast.error("An error occurred while deleting the Company File.");
    }
    setShowDeleteFileBox(false);
  };

  const cancelDeleteFile = () => {
    setShowDeleteFileBox(false);
  };





  //Table columns
  const columns = [
    { Header: "Sr.No", accessor: (row, index) => index + 1, id: "index" },
    // {
    //   Header: "Profile",
    //   accessor: "CompanyLogo",
    //   Cell: ({ row }) => (
    //     <div>
    //       <label
    //         htmlFor={`img-upload-${row.original.CompanyId}`}
    //         style={{ cursor: "pointer" }}
    //       >
    //         <img
    //           src={row.original.CompanyLogo}
    //           alt="Profile"
    //           style={{
    //             width: "40px",
    //             height: "40px",
    //             borderRadius: "50%",
    //             objectFit: "cover",
    //           }}
    //         />
    //       </label>
    //       <input
    //         type="file"
    //         id={`img-upload-${row.original.CompanyId}`}
    //         style={{ display: "none" }}
    //         onChange={(e) =>
    //           handleImageSelection(
    //             row.original.CompanyId,
    //             row.original.CompanyName,
    //             e.target.files[0]
    //           )
    //         }
    //       />
    //     </div>
    //   ),
    // },
    // {
    //   Header: "Client Company",
    //   accessor: "CompanyName",
    //   className: "table-cell capitalize-text",
    // },
    {
      Header: "Profile",
      accessor: "CompanyLogo",
      Cell: ({ row }) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <label
            htmlFor={`img-upload-${row.original.CompanyId}`}
            style={{ cursor: "pointer" }}
          >
            <img
              src={row.original.CompanyLogo}
              alt={row.original.CompanyName}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          </label>
          <span className="capitalize-text">{row.original.CompanyName}</span>
          <input
            type="file"
            id={`img-upload-${row.original.CompanyId}`}
            style={{ display: "none" }}
            onChange={(e) =>
              handleImageSelection(
                row.original.CompanyId,
                row.original.CompanyName,
                e.target.files[0]
              )
            }
          />
        </div>
      ),
    },
   
    {
      Header: "Company Type",
      accessor: "CompanyType",
      className: "table-cell capitalize-text",
    },
    {
      Header: "Email",
      accessor: "CompanyEmail",
      className: "table-cell email-cell",
      Cell: ({ row }) => (
        <span className="email-cell">
          {row.original.CompanyEmail.toLowerCase()}
        </span>
      ),
    },
    { Header: "Contact", accessor: "CompanyContact", className: "table-cell" },
    // {
    //   Header: "Address",
    //   accessor: "CompanyAddress",
    //   className: "table-cell capitalize-text",
    //   Cell: ({ row }) => {
    //     const fullAddress = `${row.original.CompanyAddress}, ${row.original.CompanyPincode}`;
    //     const truncatedAddress =
    //       fullAddress.length > 15
    //         ? `${fullAddress.substring(0, 15)}...`
    //         : fullAddress;


    //     return (
    //       <>
    //         <span>{truncatedAddress}</span>
    //         {fullAddress.length > 15 && (
    //           <Button
    //             size="small"
    //             color="primary"
    //             onClick={() => {
    //               setSelectedAddress(fullAddress);
    //               setAddressDialogOpen(true);
    //             }}
    //           >
    //             See More
    //           </Button>
    //         )}
    //       </>
    //     );
    //   },
    // },
    // {
    //   Header: "City",
    //   accessor: "City",    
    //   className: "table-cell capitalize-text",
    // },
    // {
    //   Header: "State",
    //   accessor: "State",
   
    //   className: "table-cell capitalize-text",
    // },
    // {
    //   Header: "Country",
    //   accessor: "Country",
    //   className: "table-cell capitalize-text",    
    // },
    {
      Header: "Address",
      accessor: "CompanyAddress",
      className: "table-cell capitalize-text",
      Cell: ({ row }) => {
        const parts = [
          row.original.CompanyAddress,
          row.original.CompanyPincode,
          row.original.City,
          row.original.State,
          row.original.Country
        ].filter(p => p && String(p).toLowerCase() !== "null" && String(p).trim() !== "");
        const fullAddress = parts.length > 0 ? parts.join(", ") : "-";
        
        const truncatedAddress =
          fullAddress.length > 15 ? `${fullAddress.substring(0, 15)}...` : fullAddress;
   
        return (
          <>
          <span>{truncatedAddress}</span>
        {fullAddress.length > 15 && (
          <Button
            size="small"
            color="primary"
            onClick={() => {
              setSelectedAddress(fullAddress);
              setAddressDialogOpen(true);
            }}
          >
            Read More
          </Button>
            )}
          </>
        );
      },
    },


    // Single File Upload & Preview
    {
      Header: "File",
      accessor: "CompanyAttach",
      Cell: ({ row }) => {
        const [isHovered, setIsHovered] = useState(false);
        const hasFile = !!row.original.CompanyAttach; // Check if file exists
        return (
          <div
            className="file-cell"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* If no file, show upload option */}
            {!hasFile ? (
              <>
                <label
                  htmlFor={`file-upload-${row.original.CompanyId}`}
                  className="file-upload-label"
                >
                  <FaFileUpload className="file-icon" />
                </label>
                <input
                  type="file"
                  id={`file-upload-${row.original.CompanyId}`}
                  style={{ display: "none" }}
                  onChange={(e) =>
                    handleFileUpload(row.original.CompanyId, e.target.files[0])
                  }
                />
              </>
            ) : (
              <>
                {/* Show Preview Icon */}
                <MdPreview className="file-icon" />


                {/* Show options on hover */}
                {isHovered && (
                  <div className="file-hover-options">
                    <a
                      href={row.original.CompanyAttach}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="file-option"
                    >
                      <MdPreview className="file-icon" />
                      Preview
                    </a>


                    <button
                      onClick={() => handleFileDelete(row.original)}
                      className="file-delete-button"
                    >
                      <MdDelete className="file-icon" />
                      Delete
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        );
      },
    },
  ];


  return (
    <div>
      <ToastContainer />
      {/* {loading} */}
      <div
        className="page-head"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontSize: "10px",
          marginLeft: "1%",
          marginRight: "2%",
        }}
      >
        <h1>
          <FaBuilding /> Client Company
        </h1>
        <button className="add-button" onClick={() => openModal()}>
          + Add
        </button>
      </div>


      {loading ? (
        <div className="loader-container">
          <div className="loader"></div>
          <p>Loading...</p>
        </div>
      ) : (
        <TableOne
          columns={columns}
          data={filteredCompany.slice().reverse()}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          isDeleteAction={true}
          isEditAction={true}
        />
      )}


      {/* Address */}
      <Dialog
        open={addressDialogOpen}
        onClose={() => setAddressDialogOpen(false)}
      >
        <DialogContent>
          <Typography variant="h6">Company Address</Typography>
          <Typography variant="body2">{selectedAddress}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddressDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      {showDeleteCompanyBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning />
              Confirm Delete
            </div>


            <div className="popup-message">
              Are you sure you want to remove the company{" "}
              <span className="company-name">
                <strong>{deleteCompanyName}</strong>
              </span>{" "}
              from the system?
            </div>
            <div className="popup-buttons">
              <button
                className="confirm-button"
                onClick={confirmDeleteCompany} // Trigger confirmDeleteCompany
              >
                Yes, Delete
              </button>
              <button
                className="cancel-button"
                onClick={cancelDeleteCompany} // Trigger cancelDeleteCompany
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete File Confirmation Box */}
      {showDeleteFileBox && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <CiWarning />
              Confirm Delete
            </div>
            <div className="popup-message">
              Are you sure you want to delete this file?
            </div>
            <div className="popup-buttons">
              <button
                className="confirm-button"
                onClick={confirmDeleteFile}
              >
                Yes, Delete
              </button>
              <button
                className="cancel-button"
                onClick={cancelDeleteFile}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}


      {/* // Upload Confirmation Modal for Company */}
      <Modal
        isOpen={isUploadModalOpen}
        onRequestClose={cancelImageUpload}
        contentLabel="Confirm Upload"
        className="upload-confirmation-modal"
      >
        <h2 style={{color:"#e74c3c"}}>
          <CiWarning />
          Confirm Upload
        </h2>
        <p>
          Are you sure you want to upload this logo for{" "}
          <strong>{selectedCompanyName}</strong> Comapny?
        </p>
        <div className="form-actions">
          <button onClick={confirmImageUpload} className="confirm-button">
            Yes, Upload
          </button>
          <button onClick={cancelImageUpload} className="cancel-button">
            Cancel
          </button>
        </div>
      </Modal>


      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Company Form"
        className="add-comapny-modal"
        style={{
          content: {
            width: "625px",
          },
        }}
        shouldCloseOnOverlayClick={false} //other click on screen, never close form modal
      >
        <h2>{editMode ? "Edit Client Company" : "Add Client Company"}</h2>


        <form className="company-form" onSubmit={handleSubmit}>
          {/* Row 1 */}
          <div className="form-main">
            <div className="form-row">
              <TextField
                label="Client Comapny Name"
                name="company_name"
                value={formData.company_name}
                error={!!errors.company_name}
                helperText={errors.company_name}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <AiOutlineProject />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="E-mail"
                name="company_email"
                value={formData.company_email}
                error={!!errors.company_email}
                helperText={errors.company_email}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <MdEmail />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            {/* Row-2 */}
            <div className="form-row">
              <div className="form-field">
                <TextField
                  select
                  label="Client Company Type"
                  name="company_type"
                  value={formData.company_type}
                  error={!!errors.company_type}
                  helperText={errors.company_type}
                  onChange={handleInputChange}
                  fullWidth
                  style={{ width: "295px" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        style={{ color: "black" }}
                      >
                        <MdBadge />
                      </InputAdornment>
                    ),
                  }}
                >
                  <MenuItem value="">Select Type</MenuItem>
                  <MenuItem value="Sole Proprietorship or Partnership">
                    Proprietorship or Partnership
                  </MenuItem>
                  <MenuItem value="Private Limited Company (Pvt. Ltd.)">
                    Private Limited Company (Pvt. Ltd.)
                  </MenuItem>
                  <MenuItem value="Public Limited Company">
                    Public Limited Company
                  </MenuItem>
                  <MenuItem value="Limited Liability Partnership (LLP)">
                    Limited Liability Partnership (LLP)
                  </MenuItem>
                </TextField>
              </div>
              <TextField
                label="Contact"
                name="company_contact"
                value={formData.company_contact}
                error={!!errors.company_contact}
                helperText={errors.company_contact}
                onChange={handleInputChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" style={{ color: "black" }}>
                      <FaMobileRetro />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            {/* Row-3 */}
            <div className="form-row">
              <TextField
                select
                label="Country"
                name="company_country"
                value={formData.company_country}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    company_country: e.target.value,
                    company_state: "",
                    company_city: "",
                  });
                  fetchState(e.target.value); // Fetch states when a country is selected
                }}
                fullWidth
              >
                {country.length > 0 ? (
                  country.map((countryData) => (
                    <MenuItem
                      key={countryData.CountryId}
                      value={countryData.CountryId}
                    >
                      {countryData.CountryName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No countries available</MenuItem>
                )}
              </TextField>


              <TextField
                select
                label="State"
                name="company_state"
                value={formData.company_state}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    company_state: e.target.value,
                    company_city: "",
                  });
                  fetchCity(e.target.value); // Fetch cities when a state is selected
                }}
                fullWidth
              >
                {state.length > 0 ? (
                  state.map((stateData) => (
                    <MenuItem key={stateData.StateId} value={stateData.StateId}>
                      {stateData.StateName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No states available</MenuItem>
                )}
              </TextField>


              <TextField
                select
                label="City"
                name="company_city"
                value={formData.company_city}
                onChange={(e) =>
                  setFormData({ ...formData, company_city: e.target.value })
                }
                fullWidth
              >
                {city.length > 0 ? (
                  city.map((cityData) => (
                    <MenuItem key={cityData.CityId} value={cityData.CityId}>
                      {cityData.CityName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No cities available</MenuItem>
                )}
              </TextField>
            </div>
            {/* Row-4 */}
            <div className="form-row"></div>
            <TextField
              label="Residential Address"
              name="company_address"
              id="outlined-textarea"
              value={formData.company_address}
              error={!!errors.company_address}
              helperText={errors.company_address}
              onChange={handleInputChange}
              fullWidth
              style={{ width: "400px", marginLeft: "10px" }}
              multiline
              rows={1} // You can adjust the number of rows as needed
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" style={{ color: "black" }}>
                    <FaAddressCard />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              label="Pincode"
              name="company_pincode"
              className="pincode"
              value={formData.company_pincode}
              error={!!errors.company_pincode}
              helperText={errors.company_pincode}
              onChange={handleInputChange}
              style={{ width: "190px", marginLeft: "20px" }}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" style={{ color: "black" }}>
                    <TbMapPinCode />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          {/* Actions */}
          <div className="form-actions">
            <button variant="contained" color="primary" type="submit">
              {editMode ? "Save" : "+ Add"}
            </button>
            <button
              variant="outlined"
              onClick={closeModal}
              className="close-button"
            >
              Cancel
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default Company;

